import { request } from './client.js'

export type NaskahStatus = 'DRAF' | 'DIAJUKAN' | 'DITERBITKAN' | 'DITOLAK' | 'DIARSIPKAN'

export const NASKAH_KINDS = [
  'TATA_TERTIB',
  'PAKTA_INTEGRITAS',
  'INSTRUKSI_PESERTA',
  'INFORMED_CONSENT_PS',
] as const

export type NaskahKind = (typeof NASKAH_KINDS)[number]

export interface VersionSummary {
  readonly id: string
  readonly version: number
  readonly status: NaskahStatus
  readonly title: string
  readonly contentHash: string
  readonly changeNote: string | null
  readonly createdBy: string
  readonly createdAt: string
  readonly submittedBy: string | null
  readonly submittedAt: string | null
  readonly decidedBy: string | null
  readonly decidedAt: string | null
  readonly decisionNote: string | null
}

export interface NaskahRow {
  readonly id: string
  readonly slug: string
  readonly kind: NaskahKind
  readonly name: string
  readonly berlaku: VersionSummary | null
  readonly berjalan: VersionSummary | null
}

export interface NaskahDetail {
  readonly id: string
  readonly slug: string
  readonly kind: NaskahKind
  readonly name: string
  readonly versions: readonly VersionSummary[]
}

export interface VersionDetail extends VersionSummary {
  readonly body: string
  readonly documentId: string
}

export async function listNaskah(): Promise<readonly NaskahRow[]> {
  return request<readonly NaskahRow[]>('/api/v1/naskah')
}

export async function createNaskah(input: {
  slug: string
  kind: NaskahKind
  name: string
}): Promise<NaskahRow> {
  return request<NaskahRow>('/api/v1/naskah', { method: 'POST', body: input })
}

export async function getNaskah(slug: string): Promise<NaskahDetail> {
  return request<NaskahDetail>(`/api/v1/naskah/${encodeURIComponent(slug)}`)
}

export async function getVersion(slug: string, version: number): Promise<VersionDetail> {
  return request<VersionDetail>(`/api/v1/naskah/${encodeURIComponent(slug)}/versi/${version}`)
}

export async function createDraft(
  slug: string,
  input: { title?: string; body?: string; changeNote?: string },
): Promise<VersionSummary> {
  return request<VersionSummary>(`/api/v1/naskah/${encodeURIComponent(slug)}/versi`, {
    method: 'POST',
    body: input,
  })
}

export async function saveDraft(
  slug: string,
  version: number,
  input: { title: string; body: string; changeNote?: string },
): Promise<VersionSummary> {
  return request<VersionSummary>(`/api/v1/naskah/${encodeURIComponent(slug)}/versi/${version}`, {
    method: 'PUT',
    body: input,
  })
}

type Keputusan = 'ajukan' | 'tarik' | 'setujui' | 'tolak'

export async function act(
  slug: string,
  version: number,
  action: Keputusan,
  body: Record<string, string> = {},
): Promise<VersionSummary> {
  return request<VersionSummary>(
    `/api/v1/naskah/${encodeURIComponent(slug)}/versi/${version}/${action}`,
    { method: 'POST', body },
  )
}
